import { Text } from "@clipboard-health/ui-components";
import { type ReactNode } from "react";

export interface BookabilityCriteriaCardTitleTextProps {
  children: ReactNode;
}

export function BookabilityCriteriaCardTitleText(props: BookabilityCriteriaCardTitleTextProps) {
  const { children } = props;

  return (
    <Text semibold variant="h5">
      {children}
    </Text>
  );
}
